import { Component } from '@theme/component';

class BlossyColourFilter extends Component {
  /** @param {Event} event */
  selectColour(event) {
    if (!(event.target instanceof HTMLSelectElement)) return;
    const target = new URL(event.target.value, location.origin);
    const current = new URL(location.href);
    current.searchParams.delete('page');
    if (!/\/colour-[^/]+$/.test(target.pathname)) current.searchParams.delete('from');
    target.search = current.search;
    location.assign(target.href);
  }
}

if (!customElements.get('blossy-colour-filter')) {
  customElements.define('blossy-colour-filter', BlossyColourFilter);
}

